import calendar from "./index.vue";

export default [
    {
      path: "/calendar",
      component: calendar,
      name: "Calendar",
    },
   
  ];